import { useEffect, useState } from 'react'
import PrefPicker from 'components/pref-picker'
import NestedRoutes from 'components/nested-routes'
import Information from 'views/profile/views/profile-information'
import History from 'views/profile/views/profile-history'
import Address from 'views/profile/views/profile-address'
import Phone from 'views/profile/views/profile-phone'
import useRouter from 'hooks/use-router'
import UsePercentageProfile from 'hooks/use-percentage-profle'
import textServices from 'services/text-services'
import { SectionProfileText } from '../../theme/profile'
import Identification from './views/profile-identification'

const Profile = () => {
  const { url, push, pathname } = useRouter()
  const { requiredField } = UsePercentageProfile()
  const [information, setInformation] = useState(false)
  const [address, setAddress] = useState(false)
  const [phone, setPhone] = useState(false)

  useEffect(() => {
    setInformation(["firstName", "lastName", "nickName", "email", "birthday", "genre"].filter(field => requiredField?.includes(field)).length > 0)
    setAddress(["neighborhood", "postalCode", "city", "state", "country", "street1", "streetNumber", "curp"].filter(field => requiredField?.includes(field)).length > 0)
    setPhone(["phoneNumber"].filter(field => requiredField?.includes(field)).length > 0)
  }, [requiredField])

  useEffect(() => {
    if (pathname === '/profile') {
      push('/profile/information')
    }
  }, [pathname])

  const isAllowRoute = (name: string): boolean => {
    return (THEME_CONFIG.routesProfile as string[]).includes(name)
  }

  const definitions = [
    {
      url: `${url}/information`,
      label: 'Perfil | Se navego a Mi Información',
      title: textServices.findByText('profile/information', 'MI INFORMACIÓN'),
      path: `${url}/information`,
      helper: information,
      isAllow: isAllowRoute('information'),
      component: Information
    },
    {
      url: `${url}/address`,
      label: 'Perfil | Se navego a Mi Dirección',
      title: textServices.findByText('profile/address', 'DIRECCIÓN'),
      path: `${url}/address`,
      helper: address,
      isAllow: isAllowRoute('address'),
      component: Address
    },
    {
      url: `${url}/phone`,
      label: 'Perfil | Se navego a Mi Teléfono',
      title: textServices.findByText('profile/contact', 'TELÉFONO'),
      path: `${url}/phone`,
      helper: phone,
      isAllow: isAllowRoute('phone'),
      component: Phone
    },
    {
      url: `${url}/preferences`,
      label: 'Perfil | Se navego a Preferencias',
      title: textServices.findByText('profile/pref', 'PREFERENCIAS'),
      path: `${url}/preferences`,
      isAllow: isAllowRoute('preferences'),
      component: PrefPicker
    },
    {
      url: `${url}/history`,
      label: 'Perfil | Se navego a Estado de cuenta',
      title: textServices.findByText('profile/state', 'ESTADO DE CUENTA'),
      path: `${url}/history`,
      isAllow: isAllowRoute('history'),
      component: History
    },
    {
      url: `${url}/identificacion`,
      label: 'Perfil | Se navego a identificación',
      title: textServices.findByText('profile/identification/nav', 'MI ID'),
      path: `${url}/identificacion`,
      isAllow: isAllowRoute('identificacion'),
      component: Identification
    }
  ]
  return (
    <SectionProfileText className="flex-1 flex flex-col md:mt-10 uppercase w-screen">
      <NestedRoutes definitions={definitions.filter((def) => def.isAllow)} />
    </SectionProfileText>
  )
}

export default Profile
